// client/open-href.ts
import { A } from "@adornis/base/env-info.js";
import { createRoutingObject } from "../utils/construct-routing-object.js";
import { routingStateSignal, setRoutingState } from "./routing-state-signal.js";
function openExternalHref(externalURL, {
  target = "_blank",
  inAppBrowserOptions = "toolbarposition=top,location=no",
  openFeatures
} = {}) {
  if (typeof cordova !== "undefined" && cordova.InAppBrowser) {
    const inAppBrowserRef = cordova.InAppBrowser.open(externalURL, "_blank", inAppBrowserOptions);
    const listener = (e) => {
      if (e.url.includes(A.absoluteUrl()) && !e.url.includes("/api/")) {
        inAppBrowserRef.close();
        routingStateSignal.path = `/${e.url.replace(A.absoluteUrl(), new URLSearchParams({}).toString())}`;
      }
      inAppBrowserRef.removeEventListener("loadstart", listener);
    };
    inAppBrowserRef.addEventListener("loadstart", listener);
  } else {
    window.open(externalURL, target, openFeatures);
  }
}
async function goTo(targetURL, routingOptions = {}) {
  const { origin, pathname, searchParams, hash, target, spa, replaceState } = createRoutingObject(
    targetURL,
    routingOptions,
    window.location
  );
  if (spa)
    return setRoutingState({ path: pathname, searchParams, hash, replaceState });
  else
    return openExternalHref(`${origin}${pathname}${searchParams ? `?${searchParams}` : ""}${hash ? `#${hash}` : ""}`, {
      target
    });
}
export {
  goTo
};
